import React from 'react';
import Header from '../components/Header';
import { Container } from 'react-bootstrap';
type Props = {
 children?: React.ReactNode;
};

const ProtectedLayout = ({ children }: Props) => {
 return (
  <div className="dashboard-container">
   <Header />
   <Container fluid={true}>
   <main className="main-content">
    {children}
   </main>
   </Container>
  </div>
 );
};

export default ProtectedLayout;